import { render, staticRenderFns } from "./PdfShow.vue?vue&type=template&id=24f1c5f7&scoped=true"
import script from "./PdfShow.vue?vue&type=script&lang=js"
export * from "./PdfShow.vue?vue&type=script&lang=js"
import style0 from "./PdfShow.vue?vue&type=style&index=0&id=24f1c5f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f1c5f7",
  null
  
)

export default component.exports